import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import { alerts } from 'app/components/global';
import relativeRiskDetails from '../relativeRiskDetails';
import impactAnalysisGraph from '../impactAnalysisGraph';
import recoveryPointObjectives from '../recoveryPointObjectives';
import controller from './perform-business-impact-analysis-dialog.controller';
import template from './perform-business-impact-analysis-dialog.html';


class dialogService {
  getOptions($event, { processes }) {
    return {
      controller,
      controllerAs: 'performBusinessImpactAnalysisDialogVM',
      locals: {
        processes
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.performBusinessImpactAnalysisDialog', [
  alerts,
  bcpDataService,
  constants,
  impactAnalysisGraph,
  loaderService,
  relativeRiskDetails,
  ssDialogService,
  recoveryPointObjectives,
])
  .service('performBusinessImpactAnalysisDialog', dialogService)
  .name;
